//通过Opencascad.js创建模型
import initOpenCascade from "rl-opencascade.js";
// import initOpenCascade from "@/apiWasm/rocketExample.js";
// import opencascade from "@/apiWasm/rocketExample.js";
// import opencascadeWasm from "@/apiWasm/rocketExample.wasm";

let occObj = null;

export async function initializeOpenCascade() {
  if (occObj) {
    return occObj;
  }

  return new Promise((resolve, reject) => {
    initOpenCascade()
      .then((oc) => {
        occObj = oc;
        resolve(occObj);
      })
      .catch((error) => {
        console.error("绘制库加载异常", error);
        reject(error);
      });
  });
}

export function createPrismModel(
  pointArray /* 点数组 */,
  vec /* 向量 */,
  depth /* 深度 */
) {
  try {
    if (!occObj) return null;
    const rectangle = new occObj.BRepBuilderAPI_MakeWire_1();

    let ptLength = pointArray.length;
    //按顺序添加点
    for (let i = 0; i < ptLength - 1; i++) {
      rectangle.Add_1(
        new occObj.BRepBuilderAPI_MakeEdge_3(
          new occObj.gp_Pnt_3(
            pointArray[i].x,
            pointArray[i].y,
            pointArray[i].z
          ),
          new occObj.gp_Pnt_3(
            pointArray[i + 1].x,
            pointArray[i + 1].y,
            pointArray[i + 1].z
          )
        ).Edge()
      );
    }
    rectangle.Add_1(
      new occObj.BRepBuilderAPI_MakeEdge_3(
        new occObj.gp_Pnt_3(
          pointArray[ptLength - 1].x,
          pointArray[ptLength - 1].y,
          pointArray[ptLength - 1].z
        ),
        new occObj.gp_Pnt_3(pointArray[0].x, pointArray[0].y, pointArray[0].z)
      ).Edge()
    );
    const faceMaker = new occObj.BRepBuilderAPI_MakeFace_15(
      rectangle.Wire(),
      true
    );

    if (!faceMaker.IsDone()) {
      console.log("面创建失败！");
      return null;
    }
    const face = faceMaker.Face();

    const prism = new occObj.BRepPrimAPI_MakePrism_1(
      face,
      new occObj.gp_Vec_4(vec.x * depth, vec.y * depth, vec.z * depth),
      true,
      true
    );
    const shape = prism.Shape();

    return getModelDrawData(shape);
    // while (faceExplorer.More()) {
    //   const curFace = occObj.TopoDS.Face_1(faceExplorer.Current());

    //   // 优化 4：避免重复三角化，检查是否已有三角化结果
    //   const loc = new occObj.TopLoc_Location_1();
    //   const polyTri = occObj.BRep_Tool.Triangulation(
    //     curFace,
    //     loc,
    //     occObj.Poly_MeshPurpose
    //   ).get();
    //   if (!polyTri) {
    //     faceExplorer.Next();
    //     continue;
    //   }
    //   console.log("AAAAAAAAAAAAAA", polyTri);

    //   // 获取节点数组
    //   // const nodes = polyTri.InternalUVNodes();

    //   console.log("999999");
    //   // 在遍历三角形时，直接从 nodes 中获取顶点，并在需要时进行位置变换
    //   const triangles = polyTri.InternalTriangles();
    //   console.log("888888888888888", triangles);
    //   const nbTriangles = polyTri.NbTriangles();
    //   console.log("nbTriangles", nbTriangles);

    //   for (let i = 1; i <= nbTriangles; ++i) {
    //     let n1, n2, n3;
    //     triangles.Value(i).Get(n1, n2, n3);
    //     console.log(
    //       "n1, n2, n3",
    //       triangles.Value(i).Get(n1, n2, n3),
    //       triangles.Value(i),
    //       n1,
    //       n2,
    //       n3
    //     );

    //     // 调整为 0-based 索引
    //     n1 -= 1;
    //     n2 -= 1;
    //     n3 -= 1;

    //     // 根据面片方向调整三角形顶点顺序
    //     console.log("curFace.Orientation()", curFace);

    //     if (
    //       curFace.Orientation_1() == occObj.TopAbs_Orientation.TopAbs_REVERSED
    //     ) {
    //       //   // std::swap(n1, n2);
    //     }

    //     // 获取顶点坐标
    //     // gp_Pnt p1 = nodes.Value(n1);
    //     // gp_Pnt p2 = nodes.Value(n2);
    //     // gp_Pnt p3 = nodes.Value(n3);

    //     // 仅在需要时对顶点进行位置变换
    //     if (!loc.IsIdentity()) {
    //       //   p1.Transform(loc.Transformation());
    //       //   p2.Transform(loc.Transformation());
    //       //   p3.Transform(loc.Transformation());
    //     }

    //     // 查找或添加顶点索引
    //     // int idx1 = getOrAddPointIndex(pointMap, vecPnt, rl_POINT(p1.X(), p1.Y(), p1.Z()));
    //     // int idx2 = getOrAddPointIndex(pointMap, vecPnt, rl_POINT(p2.X(), p2.Y(), p2.Z()));
    //     // int idx3 = getOrAddPointIndex(pointMap, vecPnt, rl_POINT(p3.X(), p3.Y(), p3.Z()));

    //     // 添加三角面信息
    //     // str << "{\"id\":" << nFaceIndex++ << ",\"index\":[" << idx1 << "," << idx2 << "," << idx3 << "]},";
    //   }

    //   faceExplorer.Next();
    // }

    // const translation = new occObj.gp_Trsf_1();
    // translation.SetTranslation_1(new occObj.gp_Vec_4(x, y, z));
    // const location = new occObj.TopLoc_Location_2(translation);

    // return shape.Moved(location, false);
  } catch (error) {
    console.error("创建模型失败！", error);
    return null;
  }
}

export function createRectTubeModel(
  dWidth,
  dLength,
  dThickTop,
  dThickLeft,
  dThickBot,
  dThickRight,
  dHeight
) {
  if (
    dWidth <= 0 ||
    dLength <= 0 ||
    dThickTop <= 0 ||
    dThickLeft <= 0 ||
    dThickBot <= 0 ||
    dThickRight <= 0 ||
    dHeight <= 0
  )
    return "";

  const bigBox = new occObj.BRepPrimAPI_MakeBox_3(
    new occObj.gp_Pnt_3(0, 0, 0),
    dWidth,
    dLength,
    dHeight
  );

  /*double dInnerWidth = dWidth - dWidthThick * 2;
	double dInnerLength = dLength - dLengthThick * 2;*/

  // 创建一个小立方体
  const smallBox = new occObj.BRepPrimAPI_MakeBox_3(
    new occObj.gp_Pnt_3(0, 0, 0),
    dWidth - dThickLeft - dThickRight,
    dLength - dThickTop - dThickBot,
    dHeight
  );

  // 使用布尔运算（差集）将小立方体从大立方体中掏空
  const cutOperation = new occObj.BRepAlgoAPI_Cut_3(
    bigBox.Shape(),
    smallBox.Shape(),
    new occObj.Message_ProgressRange()
  );

  // 获取结果
  const shape = cutOperation.Shape();
  return getModelDrawData(shape);
}

const getModelDrawData = (shape) => {
  //将shape三角化
  const bounds = new occObj.Bnd_Box_1();
  occObj.BRepBndLib.Add(shape, bounds, true);
  bounds.SetGap(0.0);
  let xMin, yMin, zMin, xMax, yMax, zMax;
  bounds.Get(xMin, yMin, zMin, xMax, yMax, zMax);

  const size = Math.max(xMax - xMin, yMax - yMin, zMax - zMin);
  const deflection = size * 0.1; // 将偏差设置为尺寸的 10%
  const angle = 1.0; // 约 57 度

  const mesh = new occObj.BRepMesh_IncrementalMesh_2(
    shape,
    deflection,
    false,
    angle,
    false
  );
  // const faceExplorer = new occObj.TopExp_Explorer_2(
  //   shape,
  //   occObj.TopAbs_ShapeEnum.TopAbs_FACE,
  //   occObj.TopAbs_ShapeEnum.TopAbs_SHAPE
  // );

  const exp = new occObj.TopExp_Explorer_2(
    shape,
    occObj.TopAbs_ShapeEnum.TopAbs_FACE,
    occObj.TopAbs_ShapeEnum.TopAbs_SHAPE
  );

  let totalVertices = []; //所有顶点数组
  let totalFaceDatas = [];
  while (exp.More()) {
    const face = occObj.TopoDS.Face_1(exp.Current());
    const location = new occObj.TopLoc_Location_1();

    const triangulation = occObj.BRep_Tool.Triangulation(
      face,
      location,
      occObj.Poly_MeshPurpose
    ).get();

    if (triangulation) {
      const triangles = triangulation.Triangles();

      for (let i = 1; i <= triangles.Length(); i++) {
        const tri = triangles.Value(i);
        const [n1, n2, n3] = [tri.Value(1), tri.Value(2), tri.Value(3)];
        // indices.push(n1 - 1, n2 - 1, n3 - 1);

        const pnt1 = triangulation.Node(n1);
        const pnt2 = triangulation.Node(n2);
        const pnt3 = triangulation.Node(n3);

        // 仅在需要时对顶点进行位置变换
        if (!location.IsIdentity()) {
          pnt1.Transform(location.Transformation());
          pnt2.Transform(location.Transformation());
          pnt3.Transform(location.Transformation());
        }
        // 将点转换为字符串
        let pnt1Data = pnt1.X() + "," + pnt1.Y() + "," + pnt1.Z();
        let pnt2Data = pnt2.X() + "," + pnt2.Y() + "," + pnt2.Z();
        let pnt3Data = pnt3.X() + "," + pnt3.Y() + "," + pnt3.Z();
        const vertices = [];

        if (!totalVertices.includes(pnt1Data)) {
          totalVertices.push(pnt1Data);

          vertices.push(totalVertices.length - 1);
        } else {
          vertices.push(totalVertices.indexOf(pnt1Data));
        }

        if (!totalVertices.includes(pnt2Data)) {
          totalVertices.push(pnt2Data);

          vertices.push(totalVertices.length - 1);
        } else {
          vertices.push(totalVertices.indexOf(pnt2Data));
        }

        if (!totalVertices.includes(pnt3Data)) {
          totalVertices.push(pnt3Data);

          vertices.push(totalVertices.length - 1);
        } else {
          vertices.push(totalVertices.indexOf(pnt3Data));
        }

        totalFaceDatas.push(vertices);
      }
    }
    exp.Next();
  }

  let points = totalVertices.join(",");

  let faces = "";
  totalFaceDatas.forEach((item) => {
    faces += item.join(",") + ",";
  });
  faces = faces.slice(0, -1);

  //去除points和faces的字符串引号
  let drawing_3d = `{"points":[${points.replace(
    /"/g,
    ""
  )}],"faces":[${faces.replace(/"/g, "")}]}`;

  return drawing_3d;
};
